import axios from "axios";

const apiBase = process.env.REACT_APP_API;

export const fetchAllCourses = async (showHidden = true) => {
  try {
    const response = await axios.get(
      `${apiBase}/courses/all?showHide=${showHidden}`
    );
    
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || "Failed to fetch courses";
    console.error("Error fetching courses:", error);
    throw new Error(errorMessage);
  }
};
